webpackJsonp([156897593687669],{

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _intersection = __webpack_require__(668);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Monitors scroll, and triggers the children function with updated props
	 *
	 <Observer>
	 {inView => (
	   <h1>{`${inView}`}</h1>
	 )}
	 </Observer>
	 */
	var Observer = function (_React$Component) {
	  _inherits(Observer, _React$Component);
	
	  function Observer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Observer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Observer.__proto__ || Object.getPrototypeOf(Observer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inView: false
	    }, _this.node = null, _this.handleNode = function (node) {
	      if (_this.node) (0, _intersection.unobserve)(_this.node);
	      _this.node = node;
	      _this.observeNode();
	
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this.handleChange = function (inView) {
	      _this.setState({ inView: inView });
	      if (_this.props.onChange) {
	        _this.props.onChange(inView);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Observer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // If a IntersectionObserver option changed, reinit the observer
	      if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
	        (0, _intersection.unobserve)(this.node);
	        this.observeNode();
	      }
	
	      if (prevState.inView !== this.state.inView) {
	        if (this.state.inView && this.props.triggerOnce) {
	          (0, _intersection.unobserve)(this.node);
	          this.node = null;
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.node) {
	        (0, _intersection.unobserve)(this.node);
	        this.node = null;
	      }
	    }
	  }, {
	    key: 'observeNode',
	    value: function observeNode() {
	      if (!this.node) return;
	      var _props = this.props,
	          threshold = _props.threshold,
	          root = _props.root,
	          rootMargin = _props.rootMargin,
	          rootId = _props.rootId;
	
	      (0, _intersection.observe)(this.node, this.handleChange, {
	        threshold: threshold,
	        root: root,
	        rootMargin: rootMargin
	      }, rootId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          render = _props2.render,
	          tag = _props2.tag,
	          innerRef = _props2.innerRef,
	          triggerOnce = _props2.triggerOnce,
	          threshold = _props2.threshold,
	          root = _props2.root,
	          rootId = _props2.rootId,
	          rootMargin = _props2.rootMargin,
	          props = _objectWithoutProperties(_props2, ['children', 'render', 'tag', 'innerRef', 'triggerOnce', 'threshold', 'root', 'rootId', 'rootMargin']);
	
	      var inView = this.state.inView;
	
	
	      return React.createElement(tag, _extends({}, props, {
	        ref: this.handleNode
	      }),
	      // If render is a function, use it to render content when in view
	      typeof render === 'function' ? render(inView) : null,
	      // If children is a function, render it with the current inView status.
	      // Otherwise always render children. Assume onChange is being used outside, to control the the state of children.
	      typeof children === 'function' ? children(inView) : children);
	    }
	  }]);
	
	  return Observer;
	}(React.Component);
	
	Observer.defaultProps = {
	  tag: 'div',
	  threshold: 0,
	  triggerOnce: false
	};
	exports.default = Observer;

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.observe = observe;
	exports.unobserve = unobserve;
	exports.destroy = destroy;
	var INSTANCE_MAP = new Map();
	var OBSERVER_MAP = new Map();
	
	/**
	 * Monitor element, and trigger callback when element becomes visible
	 * @param element {HTMLElement}
	 * @param callback {Function} Called with inView
	 * @param options {Object} InterSection observer options
	 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be visible before triggering
	 * @param options.root {HTMLElement} It should have a unique id or data-intersection-id in order for the Observer to reused.
	 * @param options.rootMargin {String} The CSS margin to apply to the root element.
	 * @param rootId {String} Unique identifier for the root element, to enable reusing the IntersectionObserver
	 */
	function observe(element, callback) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    threshold: 0
	  };
	  var rootId = arguments[3];
	  var root = options.root,
	      rootMargin = options.rootMargin;
	
	  var threshold = options.threshold || 0;
	  if (!element || !callback) return;
	  var observerId = rootMargin ? threshold.toString() + "_" + rootMargin : "" + threshold.toString();
	
	  if (root) {
	    observerId = rootId ? rootId + "_" + observerId : null;
	  }
	
	  var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : null;
	  if (!observerInstance) {
	    observerInstance = new IntersectionObserver(onChange, options);
	    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
	  }
	
	  var instance = {
	    callback: callback,
	    visible: false,
	    options: options,
	    observerId: observerId,
	    observer: !observerId ? observerInstance : undefined
	  };
	
	  INSTANCE_MAP.set(element, instance);
	
	  observerInstance.observe(element);
	
	  return instance;
	}
	
	/**
	 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
	 * make sure to call this method.
	 * @param element {HTMLElement}
	 */
	function unobserve(element) {
	  if (!element) return;
	  var instance = INSTANCE_MAP.get(element);
	
	  if (instance) {
	    var _observerId = instance.observerId,
	        _observer = instance.observer;
	
	    var observerInstance = _observerId ? OBSERVER_MAP.get(_observerId) : _observer;
	
	    if (observerInstance) {
	      // $FlowFixMe - the interface in bom.js is wrong. Spec should accept the element.
	      observerInstance.unobserve(element);
	    }
	
	    // Check if we are still observing any elements with the same threshold.
	    var itemsLeft = false;
	    if (_observerId) {
	      INSTANCE_MAP.forEach(function (item, key) {
	        if (item && item.observerId === _observerId && key !== element) {
	          itemsLeft = true;
	        }
	      });
	    }
	
	    if (observerInstance && !itemsLeft) {
	      // No more elements to observe for threshold, disconnect observer
	      observerInstance.disconnect();
	      OBSERVER_MAP.delete(_observerId);
	    }
	
	    // Remove reference to element
	    INSTANCE_MAP.delete(element);
	  }
	}
	
	/**
	 * Destroy all IntersectionObservers currently connected
	 **/
	function destroy() {
	  OBSERVER_MAP.forEach(function (observer) {
	    observer.disconnect();
	  });
	
	  OBSERVER_MAP.clear();
	  INSTANCE_MAP.clear();
	}
	
	function onChange(changes) {
	  changes.forEach(function (intersection) {
	    var isIntersecting = intersection.isIntersecting,
	        intersectionRatio = intersection.intersectionRatio,
	        target = intersection.target;
	
	    var instance = INSTANCE_MAP.get(target);
	
	    // Firefox can report a negative intersectionRatio when scrolling. Ignore this, and
	    if (instance && intersectionRatio >= 0) {
	      var _options = instance.options;
	
	      var _inView = false;
	
	      if (Array.isArray(_options.threshold)) {
	        // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
	        _inView = _options.threshold.some(function (threshold) {
	          return instance.visible ? intersectionRatio > threshold : intersectionRatio >= threshold;
	        });
	      } else if (_options.threshold !== undefined) {
	        // Trigger on 0 ratio only when not visible. This is fallback for browsers without isIntersecting support
	        _inView = instance.visible ? intersectionRatio > _options.threshold : intersectionRatio >= _options.threshold;
	      }
	
	      if (isIntersecting !== undefined) {
	        // If isIntersecting is defined, ensure that the element is actually intersecting.
	        // Otherwise it reports a threshold of 0
	        _inView = _inView && isIntersecting;
	      }
	
	      if (instance.callback) {
	        instance.callback(_inView);
	      }
	    }
	  });
	}
	
	exports.default = {
	  observe: observe,
	  unobserve: unobserve,
	  destroy: destroy
	};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _grayPercentage = __webpack_require__(61);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _reactIntersectionObserver = __webpack_require__(667);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	var _typography = __webpack_require__(27);
	
	var _colors = __webpack_require__(35);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable import/named */
	
	/* eslint-enable import/named */
	
	
	var ResumeWrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eklrkrd0"
	})("max-width:600px;");
	
	// Extra large header with name
	var Name = /*#__PURE__*/(0, _reactEmotion2.default)("h1", {
	  target: "eklrkrd1"
	})((0, _typography.adjustFontSizeTo)(18 * 3 + "px"), ";font-weight:700;");
	
	// Specialized list for skills (mid dot delimeter)
	var DotList = /*#__PURE__*/(0, _reactEmotion2.default)("ul", {
	  target: "eklrkrd2"
	})("list-style:none;margin:0;padding:0;li{display:inline-block;&::after{content:\"\\00b7\";display:inline-block;margin:0 5px;}&:last-child::after{content:\"\";}}");
	
	// Specialized horizontal list with contact info
	var HorizontalList = /*#__PURE__*/(0, _reactEmotion2.default)("ul", {
	  target: "eklrkrd3"
	})("list-style:none;margin:0;padding:0;font-family:", function (props) {
	  return props.sans ? ["Lato", "sans-serif"].join(", ") + ";" : "inherit";
	}, ";li{display:inline-block;padding:0 10px;border-right:1px solid ", (0, _grayPercentage2.default)(80), ";color:", (0, _grayPercentage2.default)(50), ";@media screen and (max-width:590px){display:block;border:0;padding:0;", (0, _typography.adjustFontSizeTo)("16px"), ";}&:first-child{padding-left:0;}&:last-child{padding-right:0;border-right:0;}a{color:inherit;text-decoration:none;&:hover{color:", _colors2.default.primaryColorLight, ";}}}");
	
	// Content sections and specific styling
	var Section = /*#__PURE__*/(0, _reactEmotion2.default)("section", {
	  target: "eklrkrd4"
	})("margin-top:", (0, _typography.rhythm)(2), ";");
	
	var SubSection = /*#__PURE__*/(0, _reactEmotion2.default)("section", {
	  target: "eklrkrd5"
	})("margin-top:", (0, _typography.rhythm)(1.5), ";");
	
	var SectionHeader = /*#__PURE__*/(0, _reactEmotion2.default)("h3", {
	  target: "eklrkrd6"
	})("text-transform:uppercase;font-weight:700;");
	
	var SubHeader = /*#__PURE__*/(0, _reactEmotion2.default)("span", {
	  target: "eklrkrd7"
	})("font-weight:700;color:", (0, _grayPercentage2.default)(50), ";display:block;margin-bottom:", (0, _typography.rhythm)(4 / 18), ";");
	
	// Base positioning on overall scroll position to not go past footer
	var PDFDownloadLink = /*#__PURE__*/(0, _reactEmotion2.default)("a", {
	  target: "eklrkrd8"
	})((0, _typography.adjustFontSizeTo)("12px"), ";color:", (0, _grayPercentage2.default)(50), ";text-decoration:none;display:block;position:", function (props) {
	  return props.stick ? "absolute" : "fixed";
	}, ";bottom:", function (props) {
	  return props.stick ? "calc(-" + (0, _typography.rhythm)(2) + " + 10px)" : "10px";
	}, ";right:calc((100% - 960px) / 2);transition-property:color;@media screen and (max-width:990px){position:relative;left:0;top:0;margin-bottom:", (0, _typography.rhythm)(1), ";}&:hover{color:", (0, _grayPercentage2.default)(10), ";}");
	
	var ScrollObserver = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eklrkrd9"
	})("position:absolute;width:100%;bottom:-", (0, _typography.rhythm)(2), ";left:0;display:block;");
	
	var Resume = function (_React$Component) {
	  _inherits(Resume, _React$Component);
	
	  function Resume(props) {
	    _classCallCheck(this, Resume);
	
	    // Track whether footer has been reached
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      footerInView: false
	    };
	    return _this;
	  }
	
	  Resume.prototype.render = function render() {
	    var _this2 = this;
	
	    return React.createElement(
	      ResumeWrapper,
	      null,
	      React.createElement(
	        PDFDownloadLink,
	        {
	          href: "/documents/Christian%20Gaetano%20Full%20Stack%20Web%20Developer.pdf",
	          stick: this.state.footerInView,
	          download: true
	        },
	        "Download a PDF"
	      ),
	      React.createElement(
	        _reactHelmet2.default,
	        null,
	        React.createElement(
	          "title",
	          null,
	          "Christian Gaetano \u2014 Full Stack Web Developer \u2014 Resume"
	        ),
	        React.createElement("link", { rel: "canonical", href: "https://christiangaetano.com/resume/" }),
	        React.createElement("meta", {
	          name: "description",
	          content: "For you professional types, check out a listing of my work experiences and education online. If you're stretched for time, you can download a PDF, too!"
	        })
	      ),
	      React.createElement(
	        "header",
	        null,
	        React.createElement(
	          Name,
	          null,
	          "Christian Gaetano"
	        ),
	        React.createElement(
	          "h3",
	          null,
	          "Full Stack Web Developer"
	        ),
	        React.createElement(
	          HorizontalList,
	          { sans: true },
	          React.createElement(
	            "li",
	            null,
	            "Seattle, WA"
	          ),
	          React.createElement(
	            "li",
	            null,
	            React.createElement(
	              "a",
	              { href: "mailto:hello@christiangaetano.com?subject=Nice%20to%20meet%20you!%20\uD83D\uDC4B" },
	              "hello@christiangaetano.com"
	            )
	          ),
	          React.createElement(
	            "li",
	            null,
	            React.createElement(
	              "a",
	              { href: "tel:+14129522373" },
	              "412-952-2373"
	            )
	          )
	        )
	      ),
	      React.createElement(
	        Section,
	        null,
	        React.createElement(
	          SectionHeader,
	          null,
	          "Summary"
	        ),
	        React.createElement(
	          "p",
	          null,
	          "Biochemist turned software engineer with multiple years of experience in back-end and front-end application development, JavaScript programming best practices, and marketable technical writing. Eager to transition to a challenging Front-End or Full Stack Engineering role within a team looking to innovate creative solutions at a large scale."
	        )
	      ),
	      React.createElement(
	        Section,
	        null,
	        React.createElement(
	          SectionHeader,
	          null,
	          "Employment"
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            SubHeader,
	            null,
	            "GrapeCity, Inc."
	          ),
	          React.createElement(
	            "p",
	            null,
	            "Full Stack Web Developer, Feb 2017 \u2013 Present"
	          ),
	          React.createElement(
	            "ul",
	            null,
	            React.createElement(
	              "li",
	              null,
	              "Designed and built Node.js powered static site generator based on Metalsmith platform"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Worked with back-end engineering team to implement user authentication and account management powered by MongoDB and Express.js"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Developed content search and account management applications using React and related technologies (CSS-in-JS, Flow, Babel)"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Led team-wide code quality initiatives: systematic code review, standardized linting, Gitflow Workflow"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Participated in brand style guide development and front-end UI implementation based on design mockups"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Planned and authored Modern JavaScript Frameworks e-book with hundreds of daily downloads"
	            )
	          )
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            "p",
	            null,
	            "Technical Engagement Engineer, Oct 2016 \u2013 Feb 2017"
	          ),
	          React.createElement(
	            "ul",
	            null,
	            React.createElement(
	              "li",
	              null,
	              "Provided low-level technical support and strategic consultation to corporate customers using Wijmo JavaScript UI Framework"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Authored several technical blog posts with thousands of monthly user impressions"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Developed product demos using plain JavaScript, React, Angular, and Vue"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Bridged communication between Wijmo product team and developer community, including bug report and feature request logging"
	            )
	          )
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            SubHeader,
	            null,
	            "National Science Foundation REU Leadership Group"
	          ),
	          React.createElement(
	            "p",
	            null,
	            "Design and Web Development Consultant, Jan 2016 \u2013 Feb 2018"
	          ),
	          React.createElement(
	            "ul",
	            null,
	            React.createElement(
	              "li",
	              null,
	              "Designed and produced new brand assets and strategy in collaboration with group members"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Migrated existing copy to new website with updated branding, responsive layout, and analytics tracking"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Optimized content for search visibility and target audience, increasing session duration by 400% and decreasing bounce rate by 20% over three months"
	            )
	          )
	        )
	      ),
	      React.createElement(
	        Section,
	        null,
	        React.createElement(
	          SectionHeader,
	          null,
	          "For Fun"
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            SubHeader,
	            null,
	            "CodePen PGH"
	          ),
	          React.createElement(
	            "p",
	            null,
	            "Meetup Co-organizer"
	          ),
	          React.createElement(
	            "ul",
	            null,
	            React.createElement(
	              "li",
	              null,
	              "Helped plan meetup topics and themes"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Coordinated venue procurement & snack delivery"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Promoted attendee \u201Cpens\u201D to CodePen for featured recognition"
	            )
	          )
	        )
	      ),
	      React.createElement(
	        Section,
	        null,
	        React.createElement(
	          SectionHeader,
	          null,
	          "Education"
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            SubHeader,
	            null,
	            "Duquesne University"
	          ),
	          React.createElement(
	            "p",
	            null,
	            "B.S. Biochemistry, 2012 \u2013 2016"
	          ),
	          React.createElement(
	            "ul",
	            null,
	            React.createElement(
	              "li",
	              null,
	              "Graduated Summa Cum Laude, chosen as Bayer School General Excellence Awardee"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Defended honors thesis on role of G-quadruplex RNA structures in fragile X syndrome pathogenesis"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Minor degree in mathematics"
	            )
	          )
	        )
	      ),
	      React.createElement(
	        Section,
	        null,
	        React.createElement(
	          SectionHeader,
	          null,
	          "Skills"
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            DotList,
	            null,
	            React.createElement(
	              "li",
	              null,
	              "Node.js & NPM"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "React"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Angular"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Babel"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Git"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Technical Writing"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "RESTful Architecture"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "GraphQL"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "Static Sites"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "SEO"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "MongoDB"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "MySQL"
	            )
	          )
	        )
	      ),
	      React.createElement(
	        Section,
	        null,
	        React.createElement(
	          SectionHeader,
	          null,
	          "Programming Languages"
	        ),
	        React.createElement(
	          SubSection,
	          null,
	          React.createElement(
	            DotList,
	            null,
	            React.createElement(
	              "li",
	              null,
	              "JavaScript & TypeScript (fluent)"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "C# (proficient)"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "PHP (proficient)"
	            ),
	            React.createElement(
	              "li",
	              null,
	              "C++ (prior experience)"
	            )
	          )
	        )
	      ),
	      React.createElement(
	        ScrollObserver,
	        null,
	        React.createElement(_reactIntersectionObserver2.default, {
	          onChange: function onChange(footerInView) {
	            return _this2.setState({
	              footerInView: footerInView
	            });
	          }
	        })
	      )
	    );
	  };
	
	  return Resume;
	}(React.Component);
	
	exports.default = Resume;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-js-38ee96edc2c15383c2aa.js